export const FILE_UPLOAD_SIZE_OPTIONS = [
  { value: "5242880", label: "5 MB" },
  { value: "10485760", label: "10 MB" },
  { value: "20971520", label: "20 MB" },
];

export const FILE_UPLOAD_FORMAT_OPTIONS = [
  { value: "jpg", label: "JPG" },
  { value: "jpeg", label: "JPEG" },
  { value: "png", label: "PNG" },
  { value: "pdf", label: "PDF" },
];
